export default {
  'activity.title': '活动标题',
  'activity.content': '活动内容',
  'activity.coverImage': '封面图',
  'activity.applyEnabled': '申请开关',
  'activity.applyEnabled.on': '开启',
  'activity.applyEnabled.off': '关闭',
  'activity.auditMode': '审核方式',
  'activity.auditMode.autoDispatch': '自动派单',
  'activity.auditMode.manualReview': '人工审核',
  'activity.autoRewardTickets': '门票奖励',
  'activity.cycleType': '循环方式',
  'activity.cycleType.noCycle': '无循环',
  'activity.cycleType.daily': '每日',
  'activity.cycleType.weekly': '每周',
  'activity.cycleType.monthly': '每月',
  'activity.applyLimit': '申请次数',
  'activity.submissionFields': '资料提交',
  'activity.creator.add': '添加',
  'activity.fieldType': '资料类型',
  'activity.fieldTitle': '资料标题',
  'activity.requiredField': '是否必填',
  'activity.options': '选项',
  'activity.placeholder.enterTitle': '请输入标题',
  'activity.placeholder.enterOptions': '回车确认',
  'activity.validation.enterTicketReward': '请输入门票奖励',
  'activity.validation.ticketRewardRange': '请输入 1-99 之间的整数',
  'activity.validation.selectCycleType': '请选择循环方式',
  'activity.validation.enterApplyLimit': '请输入申请次数',
  'activity.validation.applyLimitRange': '请输入 1-9999 之间的整数',
  'activity.validation.provideOptions': '请提供选项',
  'activity.validation.optionTooLong': '单个选项不可超过50字符',
  'activity.validation.optionTooMany': '最多只能添加50个选项',
  'activity.operation': '操作',
  'activity.fieldType.option.free': '任填',
  'activity.review.accountId': '账号ID',
  'activity.review.pending': '待审核',
  'activity.review.approved': '已通过',
  'activity.review.rejected': '已拒绝',
  'activity.review.batchAudit': '批量审核',
  'activity.review.audit': '审核',
  'activity.review.approve': '通过',
  'activity.review.applicationTime': '申请时间',
  'activity.review.activityTitle': '活动标题',
  'activity.review.applicationCount': '活动申请次数',
  'activity.review.submittedData': '提交资料',
  'activity.review.ticketReward': '门票奖励',
  'activity.review.enterRewardCount': '请输入奖励数量',
  'activity.fieldType.option.single': '单选',
  'activity.fieldType.option.multiple': '多选',
  'activity.fieldType.option.image': '图片',
  'activity.unit.ticket': '张',
  'activity.unit.times': '次',

  'activity.config.day': '天数',
  'activity.config.basicReward': '基础奖励',
  'activity.config.extraReward': '额外奖励',
  'activity.reward.ticket': '门票',
  'activity.reward.bonus': '奖金',
  'activity.reward.basicRequired': '请输入基础奖励',
  'activity.signIn.limit': '限制',
  'activity.signIn.beforeContestLimit': '签到前每天参加锦标赛数量',
  'activity.signIn.limitRequired': '请输入签到前每天参加锦标赛数量',
  'activity.button.add': '添加',
  'activity.pwa.reward.label': '奖励',
  'activity.pwa.reward.ticket': '门票',
  'activity.pwa.reward.bonus': '奖金',
  'activity.countdown.floatingBall': '悬浮球',
  'activity.countdown.cycle': '活动周期',
  'activity.countdown.week.mon': '周一',
  'activity.countdown.week.tue': '周二',
  'activity.countdown.week.wed': '周三',
  'activity.countdown.week.thu': '周四',
  'activity.countdown.week.fri': '周五',
  'activity.countdown.week.sat': '周六',
  'activity.countdown.week.sun': '周日',
  'activity.countdown.config.round': '轮次',
  'activity.countdown.config.countdown': '倒计时(分钟)',
  'activity.countdown.config.reward': '宝箱奖励',
  'activity.countdown.reward.noRewardTip': '无奖励, 登录多久后显示第1宝箱',
  'activity.countdown.reward.ticket': '门票',
  'activity.countdown.reward.bonus': '奖金',
  'activity.countdown.button.add': '添加',
  'activity.select.modal.title': '选择活动类型',
  'activity.select.type.custom.label': '自定义活动',
  'activity.select.type.custom.desc': '含审核机制(自动派发或人工通过)，派发门票奖励',
  'activity.select.type.countdown.label': '倒计时宝箱',
  'activity.select.type.countdown.desc': '倒计时赠送门票/奖金，可循环',
  'activity.select.type.daily.label': '每日签到',
  'activity.select.type.daily.desc': '签到即赠送门票/奖金，可循环',
  'activity.select.type.pwa.label': 'PWA安装送',
  'activity.select.type.pwa.desc': '安装PWA，赠送门票/奖金，终身一次',
  'activity.activityType': '活动类型',
  'activity.select.type.limited.label': '限时宝箱',
  'activity.select.type.limited.desc': '限时随机赠送门票/奖金，可循环',
  'activity.select.type.invite.label': '限时邀请',
  'activity.select.type.invite.desc': '限时邀请好友，赠送奖金，可重复参加',
  'activity.invite.requiredMatchesPrefix': '受邀人参加',
  'activity.invite.requiredMatchesSuffix': '锦标赛，邀请人获得奖励',
  'activity.invite.requiredMatchesRange': '请输入 0-99 的整数',
  'activity.invite.repeatable': '重复参加',
  'activity.invite.periodHours': '活动周期',
  'activity.invite.periodHoursSuffix': '小时内',
  'activity.invite.periodHoursRange': '请输入 0-999 的整数',
  'activity.invite.stage': '阶梯',
  'activity.invite.friendCount': '人数',
  'activity.invite.bonus': '奖励',
  'activity.invite.friendCountRange': '请输入 1-999 的整数',
  'activity.invite.bonusRange': '请输入 1-999999 的整数',
  'activity.select.type.bindEmail.label': '绑定邮箱',
  'activity.select.type.bindEmail.desc': '绑定邮箱即赠送门票/奖金，终身一次',
  'activity.bindEmail.reward': '奖励',
  'activity.bindEmail.ticketRange': '请输入 1-99 的整数',
  'activity.bindEmail.bonusRange': '请输入 1-9999 的整数',

  'activity.limited.mechanism': '获得机制',
  'activity.limited.randomReward': '随机获得。用户每天最高获得',
  'activity.limited.rounds': '轮次',
  'activity.limited.schedule': '排期',
  'activity.limited.validation.selectTimeRange': '请选择时间段',
  'activity.limited.validation.startBeforeEnd': '开始时间必须小于结束时间',
  'activity.limited.validation.startAfterPrev': '开始时间必须大于上一轮的结束时间',
  'activity.limited.validation.bothInputs': '必须同时输入起始和结束范围',
  'activity.limited.validation.rightGreaterEqual': '右侧数字必须大于等于左侧数字',
  'activity.limited.validation.enterTicketCount': '请输入门票数量',
  'activity.limited.validation.enterBonusAmount': '请输入奖金金额',
  'activity.invite.inviteeCondition': '受邀人条件',
  'activity.invite.requireKyc': '受邀人完成KYC，邀请人获得奖励',
  'activity.signIn.allowCrossSiteUser': '引流用户参加活动',
  'activity.signIn.allowRestrictedUser': '受限用户参加活动',
};
